import { render, staticRenderFns } from "./TemplateTypeSelectInputWidget.vue?vue&type=template&id=5bd4ec54&scoped=true"
import script from "./TemplateTypeSelectInputWidget.vue?vue&type=script&lang=js"
export * from "./TemplateTypeSelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd4ec54",
  null
  
)

export default component.exports